import {
  balloonStar,
  bookLayout,
  calc,
  gitlab,
  globeArrow,
  grafana,
  IconPeople,
  metabase,
  ones,
  personInCircle,
  sboard,
  SkolcaIconBag,
  SkolcaIconBookBookmark,
  SkolcaIconC,
  SkolcaIconCalendar,
  SkolcaIconCalendar3,
  SkolcaIconChat,
  SkolcaIconClock,
  SkolcaIconCup,
  SkolcaIconDocument,
  SkolcaIconExit,
  SkolcaIconGraph,
  SkolcaIconHandUp,
  SkolcaIconHome,
  SkolcaIconInfo,
  SkolcaIconOpenBook,
  SkolcaIconPad,
  SkolcaIconPeople,
  SkolcaIconProfilePlaceholder,
  SkolcaIconStar,
  SkolcaOnline,
  SkolcaOpenBook2,
  yatracker,
} from '@/SkolcaIcons'
import { ionAdd, ionFilter, ionTrash } from '@quasar/extras/ionicons-v8'
import { laUserSecretSolid } from '@quasar/extras/line-awesome'

import { roundAssignmentInd } from '@quasar/extras/material-icons-round'
import {
  symOutlinedArrowBack,
  symOutlinedArrowForward,
  symOutlinedArrowUpward,
  symOutlinedAttachFile,
  symOutlinedBlock,
  symOutlinedCameraswitch,
  symOutlinedCheck,
  symOutlinedCheckCircle,
  symOutlinedClose,
  symOutlinedContactPhone,
  symOutlinedCopyAll,
  symOutlinedCreditCard,
  symOutlinedDescription,
  symOutlinedDownload,
  symOutlinedEdit,
  symOutlinedEditCalendar,
  symOutlinedHelp,
  symOutlinedHourglass,
  symOutlinedHourglassTop,
  symOutlinedKeyboardArrowDown,
  symOutlinedListAlt,
  symOutlinedLogout,
  symOutlinedMail,
  symOutlinedMerge,
  symOutlinedOpenInNew,
  symOutlinedPrint,
  symOutlinedQrCode,
  symOutlinedQrCodeScanner,
  symOutlinedSave,
  symOutlinedSchema,
  symOutlinedSchool,
  symOutlinedSettings,
  symOutlinedSummarize,
  symOutlinedUndo,
  symOutlinedVisibility,
  symOutlinedWarning,
} from '@quasar/extras/material-symbols-outlined'

import { symSharpError } from '@quasar/extras/material-symbols-sharp'

import { mdiFileSign } from '@quasar/extras/mdi-v7'

export {
  SkolcaIconC as IconSkolcaC,
  ionTrash as IconRemove,
  ionAdd as IconAdd,
  symOutlinedSchool as IconSchool,
  symOutlinedLogout as IconLogout,
  symOutlinedClose as IconClose,
  symOutlinedCheckCircle as IconDone,
  symSharpError as IconError,
  symOutlinedWarning as IconWarning,
  mdiFileSign as IconSign,
  symOutlinedHourglassTop as IconWait,
  personInCircle as IconPerson,
  IconPeople as IconLk,
  SkolcaIconExit as IconExit,
  symOutlinedCreditCard as IconBankCard,
  symOutlinedHelp as IconHelp,
  symOutlinedSettings as IconSettings,
  symOutlinedAttachFile as IconAttachment,
  symOutlinedVisibility as IconEye,
  symOutlinedArrowForward as IconForward,
  symOutlinedSave as IconSave,
  symOutlinedEdit as IconEdit,
  symOutlinedDownload as IconDownload,
  symOutlinedOpenInNew as IconOpenInNew,
  SkolcaIconCalendar as IconCalendar,
  symOutlinedEditCalendar as IconCalendar2,
  SkolcaIconCalendar3 as IconCalendar3,
  SkolcaIconChat as IconChat,
  SkolcaIconBookBookmark as IconBookBookmark,
  SkolcaIconStar as IconStar,
  symOutlinedDescription as IconFile,
  SkolcaIconOpenBook as IconOpenBook,
  SkolcaOpenBook2 as IconOpenBook2,
  SkolcaIconCup as IconCup,
  SkolcaIconGraph as IconGraph,
  SkolcaIconClock as IconClock,
  symOutlinedCheck as IconChecked,
  symOutlinedArrowBack as IconBack,
  symOutlinedListAlt as IconList,
  symOutlinedSummarize as IconList2,
  symOutlinedPrint as IconPrint,
  symOutlinedMerge as IconMerge,
  laUserSecretSolid as IconSpy,
  symOutlinedCopyAll as IconCopy,
  SkolcaIconHandUp as IconHandUp,
  symOutlinedArrowUpward as IconArrowUp,
  SkolcaIconDocument as IconDocument,
  SkolcaIconPeople as IconPeople,
  symOutlinedQrCode as IconQrCode,
  symOutlinedQrCodeScanner as IconQRScanner,
  symOutlinedMail as IconMail,
  symOutlinedKeyboardArrowDown as IconChevronDown,
  symOutlinedSchema as IconSchema,
  SkolcaIconBag as IconBag,
  roundAssignmentInd as IconBadge,
  symOutlinedBlock as IconBlock,
  symOutlinedUndo as IconUndo,
  symOutlinedHourglass as IconHourglass,
  symOutlinedContactPhone as IconPhone,
  symOutlinedCameraswitch as IconCamswitch,
  ionFilter as IconFilter,
  SkolcaIconHome as IconHome,
  sboard as IconSboard,
  gitlab as IconGitlab,
  metabase as IconMetabase,
  grafana as IconGrafana,
  yatracker as IconYandexTracker,
  ones as IconOnes,
  SkolcaIconInfo as IconInfo,
  SkolcaOnline as IconOnline,
  SkolcaIconPad as IconPad,
  SkolcaIconProfilePlaceholder as IconProfilePlaceholder,
  balloonStar as IconBalloonStar,
  bookLayout as IconBookLayout,
  calc as IconCalc,
  globeArrow as IconGlobeArrow,
}
